import React, {useState, useEffect, useContext, useRef} from "react";  
import { Formik} from "formik";  
import InputTxt from "../framework/InputTxt";
import Button from "../framework/Button";
import Ribbon from "../framework/Ribbon";
import Dropdown from "../framework/DropdownObj";
import {HELP_OBJECT} from '../components/HelpObject';
import webRootContext from "../components/webrootcontext/WebRootContext";
import PhoneInput from "../framework/PhoneInput";
import TextArea from "../framework/TextArea";
import DOBInput from "../framework/DOBInput";
import Recaptcha from "react-google-recaptcha";
import { AppConfiguration } from "../framework/AppConfigProvider";
 
 function HelpForm()  {
    
	const [saveSuccess, setSaveSuccess] = useState();
	const [saveFailed, setSaveFailed] = useState();
	const [formikError, setFormikError] = useState();
	const [formSubmitted, setFormSubmitted] = useState();
	const [captchaError, setCaptchaError] = useState();
	const [dataHelpObject, setDataHelpObject] = useState(HELP_OBJECT);
	const [ticketNumber, setTicketNumber] = useState();
	const localConfig = useContext(AppConfiguration);
	
	const [responseError, setResponseError] = useState("");
	const verifyRecaptcha_api_url =  webRootContext + "/rest/captchaservice/verifyCaptcha";
	const captchaRef = useRef(null);

	const dobRef = useRef();
	const [errorMessageArray] = useState([
	    "Date of birth is required",
	    "Enter a month value between 1 and 12",
	    "Enter a day value between 1 and ",
	    "Enter a year value between 1900 and present",
	    "Enter a date in the past."
  	]);
	
	let issueDropDownList = [
		{ id:0, value: "", label: "Select one", selected: true },
	    	{ id:1, value: "Account creation/linking", label: "Signing up for an account", selected: false },
	    	{ id:2, value: "Adding a patient", label: "Adding a patient",   selected: false },
	    	{ id:3, value: "Login Issues", label: "Logging in",   selected: false },
	    	{ id:4, value: "Health Records", label: "Health Record",   selected: false },
	    	{ id:5, value: "Messaging", label: "Messages",   selected: false },
	    	{ id:6, value: "Appointments", label: "Visits",   selected: false },
	    	{ id:7, value: "MyChildren's General", label: "General questions about MyChildren's",   selected: false }
	];

	let deviceDropDownList = [
		{ id:0, value: "", label: "Select one", selected: true },
	    	{ id:1, value: "iPhone", label: "iPhone", selected: false },
	    	{ id:2, value: "iPad", label: "iPad",   selected: false },
	    	{ id:3, value: "Android", label: "Android",   selected: false },
	    	{ id:4, value: "Tablet", label: "Tablet",   selected: false },
	    	{ id:5, value: "Desktop/Laptop", label: "Desktop/Laptop",   selected: false },
	    	{ id:6, value: "Other", label: "Other",   selected: false }
	];

	let browserDropDownList = [
		{ id:0, value: "", label: "Select one", selected: true },
	    	{ id:1, value: "Chrome", label: "Chrome",   selected: false },
	    	{ id:2, value: "Edge", label: "Edge",   selected: false },
	    	{ id:3, value: "Firefox", label: "Firefox",   selected: false },
	    	{ id:4, value: "Safari", label: "Safari", selected: false },
	    	{ id:5, value: "Other", label: "Other",   selected: false },
	    	{ id:6, value: "Unknown", label: "I don't know",   selected: false }
	];

	let yesNoDropDownList = [
		{ id:0, value: "", label: "Select one", selected: true },
	    	{ id:1, value: "Yes", label: "Yes",   selected: false },
	    	{ id:2, value: "No", label: "No",   selected: false }
	];

	const saveSuccessContent = 
	<div>
		<div className="padding-bottom-20">Thank you for submitting your support request.</div>
		<div className="padding-bottom-20">Your tracking number for this issue is {ticketNumber}</div>
	</div>;
	
	const saveFailedContent = 
	<div>
		<div className="padding-bottom-20">Sorry, an error has occured.</div>
		<div className="padding-bottom-20">Please review your form below. If you problems continue, please reach out to us via phone at 617-919-4396.</div>
	</div>;

useEffect(() => {
	console.log("page loaded");
}, []); 
                  
	
	window.recaptchaOptions = {
	  useRecaptchaNet: true
	  
	};

	let captchaContent=<div></div>;
	if(localConfig.configProperties.captchaSiteKey!=null){
	  captchaContent = <Recaptcha sitekey={localConfig.configProperties.captchaSiteKey}  ref={captchaRef}  />		
	}
	
	function ValidateReCapcha(token, values){
        if(token == null  || token === ""){
            setFormSubmitted(false);
			setCaptchaError(true);
			console.log("captcha is null")
			setResponseError("Please check captcha checkbox");
			return;
        }
		
				
		 fetch(verifyRecaptcha_api_url, {
	      	method: 'POST', 
	   		headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
					},
			body: token,
	    	mode:"cors"})
 		    .then((response) => {
				 return response.status;			  
		    })
		    .then((result) => {
			    
			    if(result === 200){
				  setCaptchaError(false);
				  setResponseError("");
                  SubmitFinalForm() ;
  
			   }else{
					console.log("captcha error")
		            setFormSubmitted(false); 
					setCaptchaError(true);
					setResponseError("Please check captcha checkbox"); 
			   }			   
		  });
		   
	}
  function SubmitFinalForm() {
	let url = webRootContext + "/rest/services/createTicket";

         fetch(url, {
	      	method: 'POST', 
	   		headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
					},
			body: JSON.stringify(dataHelpObject),
	    	mode:"cors"})
 		    .then((response) => {
                 if (response.ok) {

					// Clear the form and display the success message.
					setResponseError("");
					setSaveSuccess(true);
					setSaveFailed(false);        
				    setDataHelpObject(HELP_OBJECT); 
				    
                 } else {
					setResponseError("");
					setSaveSuccess(false);
					setSaveFailed(true);        
                 }						  
				
				return response.json();
		    })
		    .then((data) => {	
					console.log("appInfo object",  data);
					setTicketNumber(data.key); 
				//	getDashboardStatusData(data.applicantId);	
				},
		    (error) => {
				setResponseError("");
				setSaveSuccess(false);
				setSaveFailed(true);        
          		console.log("error", error); 
	  		}); 
     
		console.log("Submit worked")
    }

	function validateEmail(checkemail){
		let reg = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
		return reg.test(checkemail);
	}
	
	return (
     <div>
 
		       
        <div id="formikForm">
       		  <Formik
			 	initialValues={{	
					name: "",
					email: "",
					userName: "",
					phone: "",
					patientName: "",
					patientDOB: "",
					reason: "",
					issue: "",
					device: {id:0, value:""},
					deviceOther: "",
					isApp: "",
					browser: ""
				 }}

			    
			 	validate={values => {
					 const errors = {};
					 
		        if (!values.name) {
		             errors.name = 'Your full name is required';
		         }  
				if (values.name.length >=50) {
		             errors.name = 'Your full name must be less than 50 characters';
		         }  
 
		        if (!values.email) {
		           errors.email = 'Email address is required';
		         } 
		         
		        if (values.email && (!validateEmail(values.email))){
					errors.email = "Not a valid email address format.";  
				 }         

				if (values.userName.length >=50) {
		             errors.userName = 'Username must be less than 50 characters';
		         }  

				if (!values.phone) {
					errors.phone = 'Phone number is required';
					}
					else if (!values.isValidPhoneNumber) {
						errors.phone = 'Enter a valid phone number';						
				}

		        if (!values.patientName) {
		             errors.patientName = 'Patient full name is required';
		         }  
				if (values.patientName.length >=50) {
		             errors.patientName = 'Patient full name must be less than 50 characters';
		         }  
				if (!values.patientDOB) {
		             errors.patientDOB = 'Patient date of birth is required';
		         }  

	         	if (!values.reason) {
		           errors.reason = 'Describe technical issue is required';
		         }   

	         	if (!values.issue) {
		           errors.issue = 'Issue is required';
		         }   

	         	if (values.device.id === 0) {
				   errors.device = 'Device is required';
		         }   
	         	if (!values.device) {
				   errors.device = 'Device is required';
		         } 

	         	if (values.device.id !== 5 && !values.isApp.value) {
		           errors.isApp = 'Are you using the MyChildrens App is required';
		         }

	         	if (values.device.id === 5 && !values.browser.value) {
		           errors.browser = 'Browser is required';
		         }


				if( Object.keys(errors).length > 0) {
					setFormikError(true);
					setResponseError("REVIEW ISSUES BELOW");
					}
					
					else {
						setFormikError(false);
						setFormSubmitted(false);
						setResponseError("");
			        }	
	          
			         return errors;
		       }}
			 
			 onSubmit={(values) => {
						
		          setTimeout(() => {

				  	const token = captchaRef.current.getValue();
       				captchaRef.current.reset();		  	 	          	    	          		
				  	ValidateReCapcha(token, values);
		          }, 100);
		        }}			 
			 >
			 
			   { ({
		          values ,
		          errors ,
		          touched,
		          handleChange,
		          handleBlur,
		          handleSubmit,
		          isSubmitting,
		          isValid,
		          dirty,
		          validateForm,
		          setFieldValue
		        }) => (
				
		<form onSubmit={handleSubmit} noValidate>

			<div id="formikErrors" className={(formikError && formSubmitted ? 'show_div' : 'hide_div')}>
				<div id="formikFailDiv" className="div_1_col">
					<Ribbon label="REVIEW ISSUES BELOW" status={"error"} subheader={""} content={responseError} />
				</div>
			</div>

			<div id="saveSuccess" className={(saveSuccess ? 'show_div' : 'hide_div')}>
				<div id="saveSuccessDiv" className="div_1_col">
					<Ribbon label="SUBMITTED" status={"checkmark"} subheader={""} content={saveSuccessContent} />
				</div>
			</div>
							 		 
			<div id="saveFailed" className={(saveFailed ? 'show_div' : 'hide_div')}>
				<div id="saveFailedDiv" className="div_1_col">
					<Ribbon label="ERROR" status={"error"} subheader={""} content={saveFailedContent} />
				</div>
			</div>

			
			<div id="formikErrors2" className={(captchaError ? 'show_div' : 'hide_div')}>
				<div id="formikFailDiv" className="div_1_col">
					<Ribbon label="REVIEW ISSUES BELOW" status={"error"} subheader={""} content={responseError} />
				</div>
			</div>

			<div id="headerDiv" className={(saveSuccess ? 'hide_div' : 'div_1_col padding-bottom-20')}>
				<div className="page_title">Contact Us</div>
			</div>

			<div id="formInputs" className={(saveSuccess ? 'hide_div' : 'show_div' )} >

				<div id="divPageInfo" className="div_1_col normal_txt padding-bottom-30">
					<div className="padding-bottom-20">For technical issues please fill out this form or call us at 617-919-4396. We are available Monday to Friday from 7 a.m. to 7 p.m. and Saturday from 8 a.m. to 4 p.m.</div>
					<div>For Boston Children’s billing questions, please visit <a href="https://www.childrenshospital.org/patient-resources/financial-and-billing-matters" target="_blank" rel="noopener noreferrer">Billing & Insurance</a> on the Boston Children's website.</div>
					<div>For Franciscan Children’s billing questions, visit <a href="https://franciscanchildrens.org/resources/insurance-billing/" target="_blank" rel="noopener noreferrer">Insurance & Billing</a> on the Franciscan Children's website.</div>
				</div>

		 		  	<div id="div1" className="div_3_col">		                
			 	
					 	<InputTxt
			                id="name" 
			                name="name" 
			                labelText="Your Full Name"
			                isRequired={true} 
			                errorMessage={errors.name}         
			                hasError={touched.name && errors.name}                               
			                onChange={handleChange}		               
			                onBlur={handleBlur}
							maxLength={"50"}
							value={values.name}
							getTextString={(e) => setDataHelpObject({...dataHelpObject, name: e})}
			              />

						<InputTxt
							id="email" 
							name="email" 
							labelText="Email address"
							helpMessage = ""
							isRequired={true}     
							errorMessage={errors.email}         
							hasError={touched.email && errors.email}                               
							onChange={handleChange}
							onBlur={handleBlur}     
							getTextString={(email) => setDataHelpObject({...dataHelpObject, email: email})}              
						/>
						
					 	<InputTxt
			                id="userName" 
			                name="userName" 
			                labelText="Username (If different than your email address) "
			                isRequired={false} 
			                errorMessage={errors.userName}         
			                hasError={touched.userName && errors.userName}                               
			                onChange={handleChange}		               
			                onBlur={handleBlur}
							maxLength={"50"}
							value={values.userName}
							getTextString={(e) => setDataHelpObject({...dataHelpObject, userName: e})}
			            />
						
			 			<PhoneInput
			 			    id="phone"
							name="phone"
                  			labelText={"Phone number"}
                  			isRequired={true} // add requird star
                  			isDisabled={false} // disable the inputbox
                  			showFlag={true} // without flag, US number only
                 			errorMessage={errors.phone}         
		           			hasError={touched.phone && errors.phone}               
		           			// onchange and onblur is return event, handle by formik
							onChange={(e) => {
                        		setDataHelpObject({...dataHelpObject, phone: e});
								values.phone = e;
                			}}	
                			onBlur={(e) => {
				            	touched.phone = true;
				            	//the e.phoneNumberHasError is mis-named, it is true if the number is correct 
				            	values.isValidPhoneNumber = e.phoneNumberHasError;
			            	    validateForm();
				        	}}		           			
                  			value={dataHelpObject.phone}
                		/>


					 	<InputTxt
			                id="patientName" 
			                name="patientName" 
			                labelText="Patient full name"
			                isRequired={true} 
			                errorMessage={errors.patientName}         
			                hasError={touched.patientName && errors.patientName}                               
			                onChange={handleChange}		               
			                onBlur={handleBlur}
							maxLength={"50"}
							value={values.patientName}
							getTextString={(e) => setDataHelpObject({...dataHelpObject, patientName: e})}
			              />

				 		<DOBInput
							ref={dobRef}
				 			id={"patientDOB"}
			                labelText={"Patient Date of Birth (MM DD YYYY)"}
			                isRequired={true} // add requird star
			                isDisabled={false} // disable the inputbox
			                errorMessageArray={errorMessageArray}
			                value={values.patientDOB} // formik initial Values
			                hasError={touched.patientDOB && errors.patientDOB}
			                errorMessage={errors.patientDOB}
			                allowFutureDate={false}
			                onFocus={(e) => {
			                }}

			                onChange={(e) => {
			                  values.patientDOB = e;
			                  touched.patientDOB = true;		                  
			                }}
			               
			                onBlur={(e) => {
			                  values.patientDOB = e; // return value error or date string
			                  touched.patientDOB = true;
			                  setDataHelpObject({...dataHelpObject, patientDOB: e});
			                  
			                }}
			              />

		             </div>	

				 	<div id="div2" className="div_3_col">

             		<Dropdown
			         data={issueDropDownList}
				     label="Issue"
			         isRequired={true}
			         helpMessage=""
			         isDisabled={false}
			         name="issue" 
			         id="issue" 
			         selectedItem={values.issue.id}
					 disableDefault={true}
			         getSelectedValue={(e) => {setDataHelpObject({...dataHelpObject, issue: e.value});}}
			         // show error and error message is control by formik
			         errorMessage={errors.issue}
			         hasError={touched.issue && errors.issue}
			         // return event to formik
			         onChange={(e) => {
						 errors.issue = "";
			             if (e) {
			                  setDataHelpObject({...dataHelpObject, issue: e.value});
			                  values.issue = e;
			             }
			         }}
			         onFocus={(e) => {
			         	  touched.issue = e;
			         }}
			         // update formik value
			         value={(e) => {
			              values.issue = e;
			              setDataHelpObject({...dataHelpObject, issue: e.value});
			         }}
			      />
					
				  <Dropdown
			         data={deviceDropDownList}
				     label="Device"
			         isRequired={true}
			         helpMessage=""
			         isDisabled={false}
			         name="device" 
			         id="device" 
			         selectedItem={values.device.id}
					disableDefault={true}
			         getSelectedValue={(e) => {setDataHelpObject({...dataHelpObject, device: e.value});}}
			         // show error and error message is control by formik
			         errorMessage={errors.device}
			         hasError={touched.device && errors.device}
			         // return event to formik
			         onChange={(e) => {
						 errors.device = "";
			             if (e) {
			                  setDataHelpObject({...dataHelpObject, device: e.value});
			                  values.device = e;
			             }
			         }}
			         onFocus={(e) => {
			         	  touched.device = e;
			         }}
			         // update formik value
			         value={(e) => {
			              values.device = e;
			              setDataHelpObject({...dataHelpObject, device: e.value});
			         }}
			      />

				<div id="device_other" className={(values.device.id === 6 ? 'show_div' : 'hide_div')}>
				<InputTxt
	                id="deviceOther" 
	                name="deviceOther" 
	                labelText="Other Device"
	                isRequired={false} 
	                errorMessage={errors.deviceOther}         
	                hasError={touched.deviceOther && errors.deviceOther}                               
	                onChange={handleChange}		               
	                onBlur={handleBlur}
					maxLength={"50"}
					value={values.deviceOther}
					getTextString={(e) => setDataHelpObject({...dataHelpObject, deviceOther: e})}
	              />
				</div>
				
				<div id="browser_div" className={(values.device.id === 5 ? 'show_div' : 'hide_div')}>
				  <Dropdown
			         data={browserDropDownList}
				     label="What browser are you using?"
			         isRequired={true}
			         helpMessage=""
			         isDisabled={false}
			         name="browser" 
			         id="browser" 
			         selectedItem={values.browser.id}
					disableDefault={true}
			         getSelectedValue={(e) => {setDataHelpObject({...dataHelpObject, browser: e.value});}}
			         // show error and error message is control by formik
			         errorMessage={errors.browser}
			         hasError={touched.browser && errors.browser}
			         // return event to formik
			         onChange={(e) => {
						 errors.browser = "";
			             if (e) {
			                  setDataHelpObject({...dataHelpObject, browser: e.value});
			                  values.browser = e;
			             }
			         }}
			         onFocus={(e) => {
			         	  touched.browser = e;
			         }}
			         // update formik value
			         value={(e) => {
			              values.browser = e;
			              setDataHelpObject({...dataHelpObject, browser: e.value});
			         }}
			      />
				</div>

			<div id="browser_div" className={(values.device.id !== 5 && values.device.id !== 0 ? 'show_div' : 'hide_div')}>
			  <Dropdown
			         data={yesNoDropDownList}
				     label="Are you using the MyChildrens App?"
			         isRequired={true}
			         helpMessage=""
			         isDisabled={false}
			         name="isApp" 
			         id="isApp" 
			         selectedItem={values.isApp.id}
					disableDefault={true}
			         getSelectedValue={(e) => {setDataHelpObject({...dataHelpObject, isApp: e.value});}}
			         // show error and error message is control by formik
			         errorMessage={errors.isApp}
			         hasError={touched.isApp && errors.isApp}
			         // return event to formik
			         onChange={(e) => {
						 errors.isApp = "";
			             if (e) {
			                  setDataHelpObject({...dataHelpObject, isApp: e.value});
			                  values.isApp = e;
			             }
			         }}
			         onFocus={(e) => {
			         	  touched.isApp = e;
			         }}
			         // update formik value
			         value={(e) => {
			              values.isApp = e;
			              setDataHelpObject({...dataHelpObject, isApp: e.value});
			         }}
			      />
				</div>
						<TextArea
							id="reason"
							labelText={"Describe technical issue"}
							isRequired={true}
							rows={4}
							maxLength={300}
							getTextString={(reason) => setDataHelpObject({...dataHelpObject, reason: reason} )}
							hasError={touched.reason && errors.reason}
							errorMessage={errors.reason}
							onChange={(reason) => {
								if (reason) {
									values.reason = reason;
									setDataHelpObject({...dataHelpObject, reason: reason} );
									}
								}}	
							onBlur={handleBlur}                         
							value={dataHelpObject.reason}		                
						/>

					</div>
		             <div className="div_3_col padding-bottom-30">
		             	{captchaContent}		              
		             </div>

		             <hr className="hr--light" />
		             <div className="div_1_col horizontal_div">
		             
		             <Button
		                text={"SEND"}
		                styleName={"button button--primary"}
		                id={"button_submit"}
		                type="submit"
						onClick={(e) =>{setFormSubmitted(true);validateForm(); window.scrollTo({top: 0, left: 0, behavior: 'auto'}); dobRef.current.doValidate();}}
		              />
		            </div>
		 		  
		 		  </div>     				 	
		        </form>
				 
				 
				 )}
		 </Formik>
		 </div>		 
       </div>
    )
    };

	
	
export default HelpForm;
	